function getSchoolList() {
  var schoolList = [
    'All',
    'Abilene Christian University',
    'Adams State',
    'Air Force',
    'Akron',
    'Alabama',
    'Alabama A&M',
    'Alabama State',
    'Albany',
    'Alcorn State',
    'American International College',
    'Angelo State',
    'Appalachian State',
    'Arizona',
    'Arizona State',
    'Arkansas',
    'Arkansas State',
    'Arkansas Tech',
    'Arkansas-Monticello',
    'Arkansas-Pine Bluff',
    'Army',
    'Auburn',
    'Augustana',
    'Austin Peay',
    'Avila University',
    'Ball State',
    'Baylor',
    'Bemidji State',
    'Benedict College',
    'Bentley',
    'Bethune-Cookman',
    'Birmingham Southern',
    'Bloomsburg',
    'Boise State',
    'Boston College',
    'Bowie State',
    'Bowling Green',
    'Brevard College',
    'Brigham Young',
    'Brown',
    'Bryant University',
    'Bucknell',
    'Buffalo',
    'Butler',
    'Cal Poly',
    'California',
    'California, Pa.',
    'Campbell',
    'Carson Newman College',
    'Catawba',
    'Central Arkansas',
    'Central Connecticut State',
    'Central Michigan',
    'Central Oklahoma',
    'Central Washington University',
    'Chadron State',
    'Charleston Southern',
    'Charlotte',
    'Chattanooga',
    'Cincinnati',
    'Citadel',
    'Clarion',
    'Clemson',
    'Coastal Carolina',
    'Colgate',
    'Colorado',
    'Colorado School of Mines',
    'Colorado State',
    'Colorado State Pueblo',
    'Columbia',
    'Concordia College',
    'Concordia University',
    'Connecticut',
    'Cornell',
    'Cornell College',
    'Creighton',
    'Cumberland',
    'Dartmouth',
    'Davidson',
    'Dayton',
    'Delaware',
    'Delaware State',
    'Delta State',
    'Drake',
    'Duke',
    'Duquesne',
    'East Carolina',
    'East Central University',
    'East Tennessee State',
    'Eastern Illinois',
    'Eastern Kentucky',
    'Eastern Michigan',
    'Eastern New Mexico',
    'Eastern Washington',
    'Elon',
    'Emporia State',
    'FIU',
    'Fairmont State',
    'Faulkner',
    'Ferris State',
    'Findlay',
    'Florida',
    'Florida A&M',
    'Florida Atlantic',
    'Florida Gulf Coast',
    'Florida State',
    'Florida Tech',
    'Fordham',
    'Fort Hays State',
    'Fort Valley State',
    'Fresno State',
    'Furman',
    'Gallaudet',
    'Gardner-Webb',
    'George Mason',
    'Georgetown',
    'Georgia',
    'Georgia Military',
    'Georgia Southern',
    'Georgia State',
    'Georgia Tech',
    'Grambling State',
    'Grand Valley State',
    'Hamilton',
    'Hampton',
    'Harding University',
    'Harvard',
    'Hastings College',
    'Hawaii',
    'Henderson State',
    'Holy Cross',
    'Houston',
    'Houston Baptist',
    'Howard',
    'Humboldt State',
    'IUP',
    'Idaho',
    'Idaho State',
    'Illinois',
    'Illinois State',
    'Incarnate Word',
    'Indiana',
    'Indiana State',
    'Iowa',
    'Iowa State',
    'Iowa Wesleyan',
    'Jackson State',
    'Jacksonville',
    'Jacksonville State',
    'James Madison',
    'Kansas',
    'Kansas State',
    'Kennesaw State',
    'Kent State',
    'Kentucky',
    'Kentucky Christian',
    'Kentucky State',
    'Kentucky Wesleyan',
    'Kutztown University',
    'LSU',
    'Lafayette',
    'Lake Erie College',
    'Lamar',
    'Lane College',
    'Lehigh',
    'Lenoir-Rhyne',
    'Liberty',
    'Limestone College',
    'Lindenwood University',
    'Lock Haven',
    'Louisiana Tech',
    'Louisiana-Lafayette',
    'Louisiana-Monroe',
    'Louisville',
    'Maine',
    'Malone',
    'Marist',
    'Marshall',
    'Mary Hardin-Baylor',
    'Maryland',
    'Maryville College',
    'Massachusetts',
    'Mayville State',
    'McNeese State',
    'Memphis',
    'Mercer',
    'Mercyhurst College',
    'Merrimack',
    'Methodist',
    'Miami',
    'Miami (OH)',
    'Michigan',
    'Michigan State',
    'MidAmerica Nazarene',
    'Middle Tennessee State',
    'Midwestern State',
    'Millersville',
    'Minnesota',
    'Minnesota Duluth',
    'Minnesota State Mankato',
    'Minnesota State University Moorhead',
    'Mississippi College',
    'Mississippi State',
    'Mississippi Valley State',
    'Missouri',
    'Missouri State',
    'Monmouth',
    'Montana',
    'Montana State',
    'Morehead State',
    'Morgan State',
    'Mount St. Joseph',
    'Mount Union ',
    'Murray State',
    'N.C. State',
    'Navy',
    'Nebraska',
    'Nebraska Kearney',
    'Nevada',
    'New Hampshire',
    'New Haven',
    'New Mexico',
    'New Mexico State',
    'New Orleans',
    'Newberry',
    'Nicholls State',
    'Norfolk State',
    'North Alabama',
    'North Carolina',
    'North Carolina A&T',
    'North Carolina Central',
    'North Dakota',
    'North Dakota State',
    'North Greenville',
    'North Texas',
    'Northeastern State',
    'Northern Arizona',
    'Northern Colorado',
    'Northern Illinois',
    'Northern Iowa',
    'Northern Michigan',
    'Northwest Missouri State',
    'Northwestern',
    'Northwestern Oklahoma State',
    'Northwestern State',
    'Notre Dame',
    'Notre Dame College',
    'Ohio',
    'Ohio State',
    'Oklahoma',
    'Oklahoma State',
    'Old Dominion',
    'Ole Miss',
    'Oregon',
    'Oregon State',
    'Ouachita Baptist University',
    'Paine College',
    'Penn State',
    'Pennsylvania',
    'Pittsburg State',
    'Pittsburgh',
    'Portland State',
    'Prairie View A&M',
    'Presbyterian',
    'Princeton',
    'Purdue',
    'Rhode Island',
    'Rice',
    'Richmond',
    'Robert Morris',
    'Rutgers',
    'SMU',
    'Sacramento State',
    'Sacred Heart',
    'Saginaw Valley State',
    'Sam Houston State',
    'Samford',
    'San Diego',
    'San Diego State',
    'San Jose State',
    'Savannah State',
    'Shippensburg University',
    'Shorter',
    'Siena',
    'South Alabama',
    'South Carolina',
    'South Carolina State',
    'South Dakota',
    'South Dakota State',
    'Southeast Missouri State',
    'Southeastern Louisiana',
    'Southeastern Oklahoma',
    'Southern Connecticut State',
    'Southern Illinois',
    'Southern Miss',
    'Southern Nazarene',
    'Southern University',
    'Southern Utah',
    'Southwest Baptist',
    'Southwest Minnesota State',
    'Southwestern Oklahoma State',
    "St. Augustine's",
    'St. Francis (Ill.)',
    'St. Francis (NY)',
    'St. Francis (PA)',
    'Stanford',
    'Stephen F. Austin',
    'Stetson',
    'Stillman College',
    'Stonehill College',
    'Stony Brook',
    'Syracuse',
    'TCU',
    'Tarleton State',
    'Temple',
    'Tennessee',
    'Tennessee State',
    'Tennessee Tech',
    'Tennessee-Martin',
    'Texas',
    'Texas A&M',
    'Texas A&M Commerce',
    'Texas A&M-Kingsville',
    'Texas Lutheran',
    'Texas Southern',
    'Texas State',
    'Texas Tech',
    'Texas-Permian Basin',
    'Texas-San Antonio',
    'Toledo',
    'Towson',
    'Trinity',
    'Troy',
    'Tulane',
    'Tulsa',
    'Tusculum',
    'Tuskegee',
    'UAB',
    'UC Davis',
    'UCF',
    'UCLA',
    'UMass Lowell',
    'UNLV',
    'USC',
    'USF',
    'UTEP',
    'University of Charleston',
    'Utah',
    'Utah State',
    'VCU',
    'Valdosta State',
    'Valparaiso',
    'Vanderbilt',
    'Villanova',
    'Virginia',
    'Virginia Military Institute',
    'Virginia State',
    'Virginia Tech',
    'Wagner',
    'Wake Forest',
    'Walsh',
    'Washington',
    'Washington State',
    'Wayne State',
    'Weber State',
    'West Alabama',
    'West Chester',
    'West Georgia',
    'West Texas A&M',
    'West Virginia',
    'West Virginia State',
    'Western Carolina',
    'Western Illinois',
    'Western Kentucky',
    'Western Michigan',
    'Western New Mexico',
    'Wheaton College',
    'William & Mary',
    'William Penn',
    'Wingate',
    'Winston-Salem State',
    'Wisconsin',
    'Wisconsin-Eau Claire',
    'Wisconsin-Green Bay',
    'Wittenberg',
    'Wofford',
    'Wyoming',
    'Yale',
    'Youngstown State',
  ];

  schoolList = schoolList.sort(function (a, b) {
    return a.length - b.length;
  });

  return schoolList;
}

export default getSchoolList;



// WEBPACK FOOTER //
// ./src/constants/getSchoolList.js